module.exports = __webpack_public_path__ + "img/it-service-01.46a59dde.webp";